import { render, staticRenderFns } from "./ComponentLegend.vue?vue&type=template&id=17e4a06c&"
import script from "./ComponentLegend.vue?vue&type=script&lang=js&"
export * from "./ComponentLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports